import React from 'react';
import { MapPin, Navigation, Phone, MessageCircle } from 'lucide-react';
import { branches } from '../data/mock';

export default function Branches() {
  return (
    <section id="branches" className="relative bg-white py-20 md:py-32">
      <div className="max-w-7xl mx-auto px-5 lg:px-8">
        <div className="text-center max-w-2xl mx-auto">
          <p className="section-eyebrow text-blue-600">05 — Our Branches</p>
          <h2 className="mt-4 font-anton text-3xl sm:text-4xl md:text-6xl leading-[0.95] text-slate-900">
            TRAIN <span className="text-blue-600">NEAR YOU</span>
          </h2>
        </div>

        <div className="mt-14 grid md:grid-cols-2 gap-6 max-w-5xl mx-auto">
          {branches.map((b, i) => (
            <div
              key={b.name}
              className="relative rounded-2xl p-7 bg-white ring-1 ring-slate-200 hover:ring-blue-300 hover:shadow-xl transition-all duration-300 hover:-translate-y-1 fade-up"
              style={{ animationDelay: `${i * 90}ms` }}
            >
              <span className="inline-flex items-center gap-1.5 text-blue-600 bg-blue-50 border border-blue-100 text-xs font-semibold px-2.5 py-1 rounded-full">
                <MapPin className="w-3.5 h-3.5" />
                {b.tag}
              </span>
              <h3 className="mt-4 font-anton text-2xl md:text-3xl text-slate-900">{b.name}</h3>
              <p className="mt-2 flex items-start gap-2 text-slate-600 text-sm">
                <MapPin className="w-4 h-4 mt-0.5 text-blue-600 flex-shrink-0" />
                {b.address}
              </p>

              <div className="mt-5 flex flex-wrap gap-2">
                <a href={b.mapsUrl} target="_blank" rel="noreferrer" className="inline-flex items-center gap-2 bg-blue-600 hover:bg-blue-500 text-white text-sm font-semibold px-4 py-2 rounded-full transition-colors">
                  <Navigation className="w-3.5 h-3.5" />
                  Google Maps
                </a>
                <a href={`tel:${b.phone}`} className="inline-flex items-center gap-2 bg-slate-900 hover:bg-slate-800 text-white text-sm font-semibold px-4 py-2 rounded-full transition-colors">
                  <Phone className="w-3.5 h-3.5" />
                  Call
                </a>
                <a href={`https://wa.me/${b.phone.replace(/\D/g, '')}`} target="_blank" rel="noreferrer" className="inline-flex items-center gap-2 bg-amber-500 hover:bg-amber-400 text-slate-950 text-sm font-semibold px-4 py-2 rounded-full transition-colors">
                  <MessageCircle className="w-3.5 h-3.5" />
                  WhatsApp
                </a>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
